"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 9.79 11.21 2H5v6.21L12.79 16zM7.25 5.5C6.56 5.5 6 4.94 6 4.25S6.56 3 7.25 3s1.25.56 1.25 1.25S7.94 5.5 7.25 5.5",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12.79 21 3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M11.38 17.41c.39.39.9.59 1.41.59s1.02-.2 1.41-.59l6.21-6.21c.78-.78.78-2.05 0-2.83L12.62.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41zM5 2h6.21L19 9.79 12.79 16 5 8.21z"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "7.25",
  cy: "4.25",
  r: "1.25"
}, "3")], 'DiscountTwoTone');